import React from 'react';
import Navbar from '../components/Navbar';
import HeroSectionSecondary from '../components/HeroSectionSecondary';
import '../styles/snow.css';
import { Link } from 'react-router-dom';
import CTASection from '../components/CTASection';

const Special = ()=>{
    return (
        <div>
    <Navbar />
    <HeroSectionSecondary
title="Snow Removal"
subtitle="Clear. Safe. Reliable service in Blaine & Twin Falls Counties."
button1Text="Request Snow Service"
button1Link="/contact"
button2Text="View Equipment"
button2Link="/equipment"
image="/images/snowHeroImage.png"
/>
<section className="section bg-white">
  <div className="section-inner text-center why-all-seasons">
    <h2 className="section-title">Why All Seasons?</h2>
    <div className="distinguisher-grid mt-2">
      <div className="distinguisher-card">
        <img src="/icons/iconTrust.png" alt="Trusted Legacy" className="card-icon" />
        <h3>Trusted Legacy</h3>
        <p>35+ Years in Sun Valley</p>
      </div>
      <div className="distinguisher-card">
        <img src="/icons/iconFull.png" alt="Full-Service Expertise" className="card-icon" />
        <h3>Full-Service Expertise</h3>
        <p>From design to seasonal upkeep</p>
      </div>
      <div className="distinguisher-card">
        <img src="/icons/iconLocalT.png" alt="Largest Local Team" className="card-icon" />
        <h3>Largest Local Team</h3>
        <p>60+ professionals with real experience</p>
      </div>
      <div className="distinguisher-card">
        <img src="/icons/iconLocalT.png" alt="Eco-Friendly & Safe" className="card-icon" />
        <h3>Eco-Friendly & Safe</h3>
        <p>Kid, trout & pet-safe practices</p>
      </div>
    </div>
  </div>
</section>
<section className="section bg-stone">
        <div className="section-inner text-center services-section">
          <h2 className="section-title">Featured Services</h2>
          <div className="services-grid mt-2">
            <Link to="/services/design-build" className="service-card">
              <img src="/images/service-designbuild.jpg" alt="Design/Build service" />
              <p>DESIGN/BUILD</p>
            </Link>
            <Link to="/services/hardscape" className="service-card">
              <img src= "/images/firePitAS.jpg" alt="Hardscape service" />
              <p>HARDSCAPE</p>
            </Link>
            <Link to="/services/maintenance" className="service-card">
              <img src="/images/service-maintenance.jpg" alt="Maintenance service" />
              <p>MAINTENANCE</p>
            </Link>
            <Link to="/services/snow-removal" className="service-card">
              <img src="/images/service-snow.jpg" alt="Snow Removal service" />
              <p>SNOW REMOVAL</p>
            </Link>
            <Link to="/services/fencing" className="service-card">
              <img src="/images/service-fencing.jpg" alt="Fencing service" />
              <p>FENCING</p>
            </Link>
          </div>
        </div>
      </section>
       {/* Final CTA */}
     <CTASection 
  title="Ready to start your project?"
  subtitle="Browse Our Gallery"
  galleryLink="/Gallery"
  showEmergency={false}
/>
</div>
    )
};
export default Special;